<template>
    <div class="main-container">

        <router-view></router-view>
        
        <!-- Navbar section -->
		<HeaderStartup />

		<!-- hero section -->
		<HeroStartup />


        <!-- service area  -->
        <CurveShape class="no-height">
            <template v-slot:bgcolor>
                <path style="fill: #ffffff;
                    stroke-miterlimit:10;"
                    d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"/>
            </template>
        </CurveShape>
       

        <CtaCosts />

        <div>
        
		
        <CtaPullRequest/>
    </div>

        <div class="cta-image-area_two cta-image-bg-03 section-space--ptb_90" id="start">
            <div class="container">
              <div class="section-title text-center section-space--mb_60">
                <h2 class="font-weight--bold mb-15 wow move-up">Ready to get started?</h2>
                <span class="section-text wow move-up">We've prepared a set of one-liners for your github projects, depending on the language:</span>
              </div>
              <!-- start up feature component -->
              <StartUpFeature />
            </div>
        </div>

        <!-- footer section -->
        <FooterMain FooterStyle="bg_drak-footer" />

    </div>
</template>

<script>
    import HeaderStartup from '../components/HeaderStartup'
    import HeroStartup from '../components/HeroStartup'
    import CurveShape from '../components/CurveShape'
    import StartUpFeature from '../components/StartUpFeature'
    import FooterMain from '../components/FooterMain'
    import CtaCosts from '../components/CtaCosts.vue'
import CtaPullRequest from '../components/CtaPullRequest.vue'
import ThreeStepProcess from '../components/ThreeStepProcess'
    import AppShowcaseProcessStep from '../components/AppShowcaseProcessStep'
    import ChartCircleTwo from '../components/ChartCircleTwo'

    export default {
        name: 'app',
        components: {
    HeaderStartup,
    HeroStartup,
    CurveShape,
    StartUpFeature,
    FooterMain,
    CtaCosts,
    CtaPullRequest,
    ThreeStepProcess,
    AppShowcaseProcessStep,
    ChartCircleTwo
},

        metaInfo: {
            title: 'codeperf.io - Shipping code faster!',
            htmlAttrs: {
                lang: 'en',
                amp: true
            }
        }
    }
</script>

